import style from '../style/Account.module.scss';
import className from 'classnames/bind';
import {Tabs} from "antd";
import {useDispatch} from "react-redux";
import {globalNavigate} from "../../../routes/GlobalHistory";
import {
	Button,
	Icon
} from "~/components";
import {authActions} from "~/reduxs/Auth/authSlice";

const cn = className.bind(style);

function AccountHeader({active}) {

	const dispatch = useDispatch();

	const itemsTab = [
		{key: 'info', label: 'Thông tin'},
		{key: 'password', label: 'Mật khẩu'},
	];

	const handleLogout = () => {
		localStorage.clear();
		dispatch(authActions.logout());
		globalNavigate(process.env.REACT_APP_HOMEPAGE + "/login");
	};

	const handleTabChange = (key) => {
		const path = key === 'info' ? '/profile' : `/account/${key}`;
		globalNavigate(`${process.env.REACT_APP_HOMEPAGE}${path}`);
	};

	return (
		<section className={cn('page-head')}>
			<div>
				<h1 className={cn('page-title')}>Hồ sơ cá nhân</h1>
				<p className={cn('page-sub')}>Quản lý thông tin cá nhân và mật khẩu đăng nhập</p>
			</div>
			<Button background red leftIcon={Icon.logout} onClick={handleLogout}>Đăng xuất</Button>

			<div className={cn('page-tabs')}>
				<Tabs activeKey={active} items={itemsTab} onChange={handleTabChange} />
			</div>
		</section>
	);
}

export default AccountHeader;
